import { Action, createAction, props } from '@ngrx/store';

export enum PublicSessionStateActionTypes {
  LoadPublisSessionStates = '[PublisSessionState] Load PublisSessionStates',
  ScrollToPhotoGroupId = '[PublicSession] ScrollToIndex',
  SetSearchPhrase = '[PublicSession] SetSearchPhrase',
  SetSearchMatchingList = '[PublicSession] SetSearchMatchingList',
  MarginsUpdated = '[PublicSession] MarginsUpdated',
}

export class LoadPublicSessionStates implements Action {
  readonly type = PublicSessionStateActionTypes.LoadPublisSessionStates;
}

export const scrollToIndex = createAction(
  PublicSessionStateActionTypes.ScrollToPhotoGroupId,
  props<{
    index: number;
  }>()
);
export const setSearchPhrase = createAction(
  PublicSessionStateActionTypes.SetSearchPhrase,
  props<{
    searchPhrase: string;
  }>()
);
export const setSearchMatch = createAction(
  PublicSessionStateActionTypes.SetSearchMatchingList,
  props<{
    match: Array<string> | null;
  }>()
);
export const updateMargin = createAction(
  PublicSessionStateActionTypes.MarginsUpdated
);
export type PublicSessionStateActions = LoadPublicSessionStates;
